export function questionTitle(question) {
  const title = question.question_title || question.question_key
  // Form instructions are not analytics labels. Keep the original in question details.
  return title.replace(/\s*\(\s*select from below\s*\)\s*$/i, '').trim() || title
}
